import { toast } from 'react-toastify'

import { api } from 'api'
import { Info, Success } from 'constants/actionMessages'
import { RtmGroup } from 'interfaces/api/rtmGroups.interfaces'
import { CreateRtmGroupParams, RemoveRtmGroupParams, UpdateRtmGroupParams } from 'interfaces/store/rtmGroups.interfaces'
import { createAction, createAsyncThunk } from 'modules/store'
import { ValidationErrorsApi } from 'packages/api'

export const getAllRtmGroups = createAsyncThunk('rtmGroups/getAllRtmGroups', async (_, { rejectWithValue }) =>
  api.rtmGroups.getAll().catch((error) => rejectWithValue(error.message)),
)

export const setRtmGroupValidationErrors = createAction<ValidationErrorsApi | null>(
  'rtmGroups/setRtmGroupValidationErrors',
)

export const createRtmGroup = createAsyncThunk(
  'rtmGroups/createRtmGroup',
  async (params: CreateRtmGroupParams, { rejectWithValue, dispatch }) =>
    api.rtmGroups
      .create(params.data)
      .then((data) => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        dispatch(setRtmGroupValidationErrors(null))
        toast.success(Success.RtmGroupCreated)
        return data
      })
      .catch((error) => {
        if (error.validation) {
          dispatch(setRtmGroupValidationErrors(error.validation))
          return
        }
        return rejectWithValue(error.message)
      }),
)

export const updateRtmGroup = createAsyncThunk(
  'rtmGroups/updateRtmGroup',
  async (params: UpdateRtmGroupParams, { rejectWithValue, dispatch }) =>
    api.rtmGroups
      .update(params.id, params.data)
      .then((data) => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        dispatch(setRtmGroupValidationErrors(null))
        toast.success(Success.Save)
        return data
      })
      .catch((error) => {
        if (error.validation) {
          dispatch(setRtmGroupValidationErrors(error.validation))
          return
        }
        return rejectWithValue(error.message)
      }),
)

export const removeRtmGroup = createAsyncThunk(
  'rtmSettings/removeRtmGroup',
  async (params: RemoveRtmGroupParams, { rejectWithValue }) =>
    api.rtmGroups
      .remove(params.id)
      .then(() => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        toast.info(Info.RtmGroupRemoved)
        return
      })
      .catch((error) => rejectWithValue(error.message)),
)

export const setSingleRtmGroup = createAction<RtmGroup | null>('rtmGroups/setSingleRtmGroup')
